import { jsxs, jsx } from "react/jsx-runtime";
import { Box, Stack, Heading, Text, Badge, Hidden } from "braid-design-system";
import { BulletPoints } from "../BulletPoints/BulletPoints.mjs";
import { MAX_CARDS_PER_SLIDE } from "../Carousel/Carousel.mjs";
import { header, description, links, carousel, carouselItem, companyLogoDimensions, reviews, jobCount } from "./Placeholder.css.mjs";
const dummyMoveSlide = () => {
};
const Placeholder = ({
  onReviewsLandingPage,
  hideReviews = false,
  hideJobs = false
}) => {
  const sectionSpace = onReviewsLandingPage ? "medium" : "large";
  return /* @__PURE__ */ jsxs(Box, { position: "relative", children: [
    /* @__PURE__ */ jsxs(Stack, { space: sectionSpace, children: [
      onReviewsLandingPage ? /* @__PURE__ */ jsxs(
        Box,
        {
          display: "flex",
          justifyContent: "spaceBetween",
          flexDirection: { mobile: "columnReverse", tablet: "row" },
          children: [
            /* @__PURE__ */ jsxs(Box, { children: [
              /* @__PURE__ */ jsx(Box, { marginBottom: "medium", className: header.onReviewsPage }),
              /* @__PURE__ */ jsx(Box, { className: description.onReviewsPage }),
              /* @__PURE__ */ jsx(
                Box,
                {
                  className: description.onReviewsPage,
                  display: { tablet: "none" },
                  marginTop: "small"
                }
              )
            ] }),
            /* @__PURE__ */ jsx(
              Box,
              {
                display: "flex",
                marginBottom: { mobile: "xlarge", tablet: "none" },
                children: /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Box, { className: links.writeAReview }) })
              }
            )
          ]
        }
      ) : /* @__PURE__ */ jsxs(Stack, { space: "small", children: [
        /* @__PURE__ */ jsx(Box, { background: "neutralLight", className: header.default, children: /* @__PURE__ */ jsx(Heading, { level: "3", children: " " }) }),
        /* @__PURE__ */ jsx(Box, { background: "neutralLight", className: description.default, children: /* @__PURE__ */ jsx(Text, { children: " " }) })
      ] }),
      /* @__PURE__ */ jsx(Box, { className: carousel, children: Array(MAX_CARDS_PER_SLIDE).fill(0).map(
        (_, i) => onReviewsLandingPage ? /* @__PURE__ */ jsx(Box, { className: carouselItem.onReviewsPage }, i) : /* @__PURE__ */ jsx(
          Box,
          {
            boxShadow: "borderNeutralLight",
            padding: "gutter",
            borderRadius: "large",
            className: carouselItem.default,
            children: /* @__PURE__ */ jsxs(Stack, { space: "medium", children: [
              /* @__PURE__ */ jsx(
                Box,
                {
                  background: "neutralLight",
                  borderRadius: "standard",
                  className: companyLogoDimensions
                }
              ),
              /* @__PURE__ */ jsxs(Box, { children: [
                /* @__PURE__ */ jsx(
                  Box,
                  {
                    display: "block",
                    borderRadius: "standard",
                    background: "neutralLight",
                    children: /* @__PURE__ */ jsx(Text, { children: " " })
                  }
                ),
                /* @__PURE__ */ jsx(Text, { children: /* @__PURE__ */ jsx("br", {}) }),
                /* @__PURE__ */ jsx(Text, { children: " " })
              ] }),
              !hideReviews ? /* @__PURE__ */ jsx(
                Box,
                {
                  display: "block",
                  borderRadius: "standard",
                  background: "neutralLight",
                  className: reviews,
                  children: /* @__PURE__ */ jsx(Text, { size: "small", children: " " })
                }
              ) : null,
              !hideJobs ? /* @__PURE__ */ jsx(
                Box,
                {
                  display: "block",
                  borderRadius: "standard",
                  background: "neutralLight",
                  className: jobCount,
                  children: /* @__PURE__ */ jsx(Box, { opacity: 0, children: /* @__PURE__ */ jsx(Badge, { children: " " }) })
                }
              ) : null
            ] })
          },
          i
        )
      ) })
    ] }),
    /* @__PURE__ */ jsx(Hidden, { below: "desktop", children: /* @__PURE__ */ jsx(Box, { paddingTop: "small", children: /* @__PURE__ */ jsx(
      BulletPoints,
      {
        focusedSlideIndex: -1,
        moveSlidesLeft: dummyMoveSlide,
        moveSlidesRight: dummyMoveSlide,
        onReviewsLandingPage
      }
    ) }) }),
    !onReviewsLandingPage && /* @__PURE__ */ jsx(
      Box,
      {
        background: "neutralLight",
        height: "touchable",
        borderRadius: "standard",
        marginTop: { mobile: sectionSpace, desktop: "none" },
        className: links.bottom
      }
    )
  ] });
};
export {
  Placeholder
};
